// Shared form styles for the note creator and editor dialogs.
export const createNoteFormStyles = ({ ui: { colors, type, space } }) => ({
	form: {
		gap: space.md,
	},
	field: {
		gap: 6,
	},
	label: {
		...type.secondarySemibold,
		color: colors.text,
	},
	multilineInput: {
		height: 100,
	},
});
